import React, { useState, useEffect } from 'react';
import { getIndonesianMovies } from '../services/tmdbService';
import SectionHeader from './SectionHeader';
import MediaGridCard from './MediaGridCard';
import Pagination from './Pagination';
import LoadingSpinner from './LoadingSpinner';
import '../styles/main.css';

const Indonesian = () => {
  const [indonesianMovies, setIndonesianMovies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIndonesian = async () => {
      setLoading(true);

      try {
        setIndonesianMovies(
          await getIndonesianMovies(currentPage)
        );
      } catch (error) {
        console.error(
          'Error fetching Indonesian movies:',
          error
        );
      } finally {
        setLoading(false);
      }
    };

    fetchIndonesian();
  }, [currentPage]);

  const handlePageChange = (direction) => {
    setCurrentPage((prev) =>
      direction === 'next'
        ? prev + 1
        : Math.max(prev - 1, 1)
    );
  };

  return (
    <section
      className="content-section"
      id="indonesian"
    >
      <SectionHeader
        title="Indonesian Movies"
        icon="fi fi-id"
      />

      {loading ? (
        <LoadingSpinner label="Loading Indonesian movies" />
      ) : (
        <div className="media-grid">
          {indonesianMovies
            .slice(0, 20)
            .map((indonesian) => (
              <MediaGridCard
                key={indonesian.id}
                item={indonesian}
                linkTo={`/movie/${indonesian.id}`}
                icon="fa-star"
              />
            ))}
        </div>
      )}

      <Pagination
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </section>
  );
};

export default Indonesian;